import type { CalibrationStep } from './types';

export const CALIBRATION_STEPS: CalibrationStep[] = [
  {
    id: 'noise',
    kind: 'noise',
    label: 'Stay quiet and keep still.',
    prepMs: 2200,
    durationMs: 1800,
  },
  {
    id: 'single-c4-soft',
    kind: 'single',
    label: 'Play middle C softly and hold it.',
    prepMs: 2400,
    expectedMidi: [60],
    promptMidi: [60],
    promptVelocity: 0.45,
    durationMs: 2100,
  },
  {
    id: 'single-c4-loud',
    kind: 'single',
    label: 'Play middle C loudly and hold it.',
    prepMs: 2600,
    expectedMidi: [60],
    promptMidi: [60],
    promptVelocity: 0.82,
    durationMs: 2200,
  },
  {
    id: 'single-low',
    kind: 'single',
    label: 'Play C3, one octave below middle C, and hold it.',
    prepMs: 2200,
    expectedMidi: [48],
    promptMidi: [48],
    durationMs: 2100,
  },
  {
    id: 'single-mid',
    kind: 'single',
    label: 'Play G4, the G above middle C, and hold it.',
    prepMs: 2200,
    expectedMidi: [67],
    promptMidi: [67],
    durationMs: 2100,
  },
  {
    id: 'single-high',
    kind: 'single',
    label: 'Play G5, one octave above G4, and hold it.',
    prepMs: 2200,
    expectedMidi: [79],
    promptMidi: [79],
    durationMs: 2100,
  },
  {
    id: 'chord-close',
    kind: 'chord',
    label: 'Play a close 2-note interval or triad.',
    prepMs: 2400,
    promptMidi: [60, 64, 67],
    minDistinctMidis: 2,
    durationMs: 2300,
  },
  {
    id: 'chord-wide',
    kind: 'chord',
    label: 'Play a wider interval or chord.',
    prepMs: 2400,
    promptMidi: [48, 60, 72],
    minDistinctMidis: 2,
    durationMs: 2300,
  },
];
